import { fetchEndpointData } from '@utils/fetchEndpointData';
import { DocumentCategory } from 'src/types/enums';

import type { DocumentIdRef } from './endpoints/DocumentActionsEndpoint.types';

const BASE = '/api/v1/documents';

export function constructDownloadUrl(data: { documentId: string; documentHash: string }) {
  return `/api/v1/document/download?documentId=${encodeURIComponent(data.documentId)}&hash=${encodeURIComponent(data.documentHash)}`;
}

// --- Mutations (async fetchers; callers wrap in try/catch) ---

export async function verifyDocumentCategory(id: string, category: DocumentCategory): Promise<DocumentIdRef> {
  return fetchEndpointData<DocumentIdRef>(`${BASE}/verify-category`, {
    method: 'POST',
    body: { id, category },
  });
}

export async function rotateDocumentPages(id: string, pages: number[], rotation: number): Promise<DocumentIdRef> {
  return fetchEndpointData<DocumentIdRef>(`${BASE}/rotate-pages`, {
    method: 'POST',
    body: { id, pages, rotation },
  });
}
